module.exports = __webpack_public_path__ + "themes/mf/img/prize-tmp.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/prize-tmp.png
// module id = 104
// module chunks = 3